<template>
   <div id="container">
      <OrganizationList
         :hide-personal="true"
         :default-open="true"
         after-select-organization-url="/orgs/setup"
         after-create-organization-url="/orgs/setup"
      />
   </div>
</template>

<script setup lang="ts">
import { OrganizationList } from "@clerk/vue"
import { onMounted } from "vue"
import { hasStripePriceId } from "@/services/clerk"

onMounted(async () => {
   const showCreateButton = await hasStripePriceId()
   if (!showCreateButton) {
      // Hide the create org button if user doesn't have a price ID
      const style = document.createElement("style")
      style.textContent =
         ".cl-organizationListCreateOrganizationActionButton { display: none !important; }"
      document.head.appendChild(style)
   }
})
</script>

<style lang="scss" scoped>
#container {
   display: flex;
   justify-content: center;
   align-items: center;
   height: 100vh;
   background-color: #f5f5f5;
   background-image: linear-gradient(to top right, #007bff, #00aaff);
}
</style>
